import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import './DateRangePicker.css';

const DateRangePicker = ({ dateRange, onDateRangeChange, navData }) => {
  const [dataAvailability, setDataAvailability] = useState(null);

  useEffect(() => {
    if (navData && navData.nav_data && Array.isArray(navData.nav_data)) {
      // Extract date range from NAV data array
      const dates = navData.nav_data
        .map(item => item.date)
        .filter(d => d)
        .map(d => new Date(d))
        .filter(d => !isNaN(d.getTime()));

      if (dates.length > 0) {
        const minDate = new Date(Math.min(...dates));
        const maxDate = new Date(Math.max(...dates));
        setDataAvailability({ minDate, maxDate });
      }
    }
  }, [navData]);

  const handleStartDateChange = (date) => {
    onDateRangeChange({
      ...dateRange,
      startDate: date
    });
  };

  const handleEndDateChange = (date) => {
    onDateRangeChange({
      ...dateRange,
      endDate: date
    });
  };

  const setPresetRange = (months) => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - months);
    
    onDateRangeChange({
      startDate,
      endDate
    });
  };

  return (
    <div className="date-range-picker">
      <div className="date-inputs">
        <div className="date-input-group">
          <label>Start Date:</label>
          <DatePicker
            selected={dateRange.startDate}
            onChange={handleStartDateChange}
            selectsStart
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            maxDate={dateRange.endDate || new Date()}
            minDate={dataAvailability?.minDate}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select start date"
            className="date-input"
          />
        </div>

        <div className="date-input-group">
          <label>End Date:</label>
          <DatePicker
            selected={dateRange.endDate}
            onChange={handleEndDateChange}
            selectsEnd
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            minDate={dateRange.startDate}
            maxDate={new Date()}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select end date"
            className="date-input"
          />
        </div>
      </div>

      <div className="preset-ranges">
        <p>Quick Select:</p>
        <div className="preset-buttons">
          <button onClick={() => setPresetRange(6)}>6 Months</button>
          <button onClick={() => setPresetRange(12)}>1 Year</button>
          <button onClick={() => setPresetRange(24)}>2 Years</button>
          <button onClick={() => setPresetRange(36)}>3 Years</button>
          <button onClick={() => setPresetRange(60)}>5 Years</button>
        </div>
      </div>

      {dataAvailability && (
        <div className="data-availability">
          <p className="availability-info">
            📊 Data available from {dataAvailability.minDate.toLocaleDateString()} to {dataAvailability.maxDate.toLocaleDateString()}
          </p>
        </div>
      )}

      {!dateRange.startDate && !dateRange.endDate && (
        <div className="date-note">
          <p>
            💡 If no date range is selected, all available historical data will be used for optimization.
          </p>
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;